import React from 'react';

function badgeType(tipo) {
    if (tipo === 'percent') return { txt: '%', cls: 'cupon-badge cupon-badge--blue' };
    if (tipo === 'fixed') return { txt: '$', cls: 'cupon-badge cupon-badge--green' };
    return { txt: '—', cls: 'cupon-badge' };
}

function fmtDate(dt) {
    if (!dt) return '—';
    return String(dt).slice(0, 16).replace('T', ' ');
}

function fmtUso(usos, max) {
    const u = Number(usos || 0);
    const m = max == null ? null : Number(max);
    if (!m) return String(u);
    return `${u} / ${m}`;
}

export default function CuponesTable({ items, loading, onEdit, onAssign, onRedenciones, onToggle }) {
    const list = Array.isArray(items) ? items : [];

    return (
        <div className="cupon-table-wrap">
            <div className="cupon-table">
                <div className="cupon-table__head">
                    <div>Código</div>
                    <div>Tipo</div>
                    <div>Valor</div>
                    <div>Vigencia</div>
                    <div>Usos</div>
                    <div>Estado</div>
                    <div className="cupon-table__right">Acciones</div>
                </div>

                {loading && (
                    <div className="cupon-table__empty">
                        Cargando...
                    </div>
                )}

                {!loading && list.length === 0 && (
                    <div className="cupon-table__empty">
                        No hay cupones con estos filtros.
                    </div>
                )}

                {!loading && list.map((c) => {
                    const b = badgeType(c.tipo_descuento);
                    const activo = Number(c.activo) === 1;

                    return (
                        <div key={c.id} className={`cupon-row ${activo ? '' : 'cupon-row--off'}`}>
                            <div className="cupon-code">
                                <div className="cupon-code__main">{c.codigo}</div>
                                <div className="cupon-code__sub">{c.titulo || '—'}</div>
                            </div>

                            <div>
                                <span className={b.cls}>{b.txt}</span>
                            </div>

                            <div className="cupon-value">
                                {c.tipo_descuento === 'percent' ? `${Number(c.valor)}%` : `$${Number(c.valor)} ${c.moneda || 'USD'}`}
                            </div>

                            <div className="cupon-dates">
                                <div><b>Inicia:</b> {fmtDate(c.inicia_at)}</div>
                                <div><b>Expira:</b> {fmtDate(c.expira_at)}</div>
                            </div>

                            <div className="cupon-uses">
                                {fmtUso(c.usos_total, c.max_usos_total)}
                                <div className="cupon-uses__sub">
                                    <span>por cliente:</span> {c.max_usos_por_cliente == null ? '—' : c.max_usos_por_cliente}
                                </div>
                            </div>

                            <div>
                                <button
                                    className={`cupon-pill ${activo ? 'cupon-pill--on' : 'cupon-pill--off'}`}
                                    type="button"
                                    onClick={() => onToggle?.(c)}
                                    title={activo ? 'Desactivar' : 'Activar'}
                                >
                                    <span className="cupon-pill__dot" aria-hidden="true" />
                                    {activo ? 'Activo' : 'Inactivo'}
                                </button>
                            </div>

                            <div className="cupon-actions">
                                <button className="cupon-iconbtn" type="button" title="Editar" onClick={() => onEdit?.(c)}>
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M4 20h4l10.5-10.5a2 2 0 0 0 0-2.8l-.2-.2a2 2 0 0 0-2.8 0L5 16v4Z" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
                                        <path d="M13.5 6.5 17.5 10.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                    </svg>
                                </button>

                                <button className="cupon-iconbtn" type="button" title="Asignar" onClick={() => onAssign?.(c)}>
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M16 11a4 4 0 1 0-8 0" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                        <path d="M4 21a8 8 0 0 1 16 0" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                        <path d="M19 8v6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                        <path d="M22 11h-6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                    </svg>
                                </button>

                                <button className="cupon-iconbtn" type="button" title="Redenciones" onClick={() => onRedenciones?.(c)}>
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M7 3h10v18H7z" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
                                        <path d="M9 7h6M9 11h6M9 15h6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
